import React from 'react';
import ReactDOM from 'react-dom/client';
import '@tabler/icons-webfont/dist/tabler-icons.min.css';
import './index.scss';
import './components/edges/edgeProgress.css';
import App from './App';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { applyCancelTokenInterceptor, baseURLExecute, interceptorExecute } from './services/API';

baseURLExecute();
interceptorExecute();
applyCancelTokenInterceptor();

const root = ReactDOM.createRoot(
   document.getElementById('root') as HTMLElement
);
root.render(
   <React.StrictMode>
      <Provider store={ store }>
         <App />
      </Provider>
   </React.StrictMode>
);